// Copyright (c) 2017 Deere & Company

import t from 'tcomb';

const TcsmApproveDenyModal = t.struct({
    actionToTake: t.String,
    isVisible: t.Boolean
}, 'TcsmApproveDenyModal');

export const getDefaultState = () =>
    new TcsmApproveDenyModal({
        actionToTake: '',
        isVisible: false
    });

export default TcsmApproveDenyModal;



// WEBPACK FOOTER //
// ./src/tcsm/wip/state/tcsm-approve-deny-modal.js